import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import { responseSelector } from "../utils/helpers/selectors";
import "react-datepicker/dist/react-datepicker.css";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

function AddSuscripcion({ history, match }) {
  const dispatch = useDispatch();
  const modelCreateSuscripcion = useSelector(
    (state) => state.createSuscripcion
  );
  const modelPlanes = useSelector((state) => state.getPlanes);
  const modelName = useSelector((state) => state.suscripcionByCi);
  const [planesOptions, setPlanesOptions] = useState([]);
  const [ci, setCi] = useState("");
  const [nombre, setNombre] = useState("");
  const [plan, setPlan] = useState("");
  const [fecha, setFecha] = useState("");
  const [documentoSearch, setDocumentoSearch] = useState("");
  const [documentFound, setDocumentFound] = useState(false);

  useEffect(() => {
    const { data, error } = responseSelector(modelPlanes);

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      const options = data.items.map((row) => ({
        ...row,
        value: row._id,
        label: row.description,
        path: row.label,
      }));
      setPlanesOptions(options);
      dispatch(controller.duck.actions.clear());
    }
  }, [modelPlanes]);

  useEffect(() => {
    dispatch(
      controller.getPlanesThunk(match.params.localId, null, null, "ACTIVO")
    );
  }, []);

  useEffect(() => {
    const { data, error } = responseSelector(modelCreateSuscripcion);

    if (error) {
      alert(error?.message || "Ocurrió un error al realizar la operación");
      dispatch(controller.createSuscripcionDuck.actions.clear());
    }
    if (data) {
      history.push(`/suscripcionesByLocal/${match.params.localId}`);
      dispatch(controller.createSuscripcionDuck.actions.clear());
    }
  }, [modelCreateSuscripcion]);

  useEffect(() => {
    const data = modelName?.data?.data;
    const error = modelName?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSuscripcionByCi.actions.clear());
    }
    if (data) {

      if (data.data) {
        setNombre(data.data.nombrePersona);
        setCi(documentoSearch);
        setDocumentFound(true)
      } else {
        setDocumentFound(false)
        setCi(documentoSearch);
      }

      dispatch(controller.duckSuscripcionByCi.actions.clear());
    }
  }, [modelName]);

  function submit() {
    if (!plan || !ci || !nombre || !fecha || !match.params.localId) {
      alert("Por favor complete todos los campos");
      return;
    }
    const planSelected = planesOptions.filter((fila) => {
      if (fila._id === plan) {
        return true;
      }
    });

    let data = {
      plan: planSelected[0],
      ci,
      nombre,
      localId: match.params.localId,
      iniDate: moment(fecha).format("YYYY-MM-DD"),
    };

    dispatch(controller.createSuscripcionThunk(data));
  }

  function search() {
    if (!documentoSearch) {
      alert("Por favor proporcione un documento");
      return;
    }

    let data = {
      ci: documentoSearch,
      localId: match.params.localId
    };

    dispatch(controller.getSuscripcionByCiThunk(data));
  }

  return (
    <Content
      title="Nueva suscripción"
      browserTitle="Nueva suscripción"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nueva suscripción"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/suscripcionesByLocal/${match.params.localId}`
                    );
                  }}
                />

                <Button
                  margin={true}
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />
            <div style={{ marginBottom: 30 }}>
              <Text
                labelPosition="above"
                size="sm"
                inputType="number"
                label={<Etiqueta texto="Documento" obligatorio={true} />}
                value={documentoSearch}
                onChange={(evt) => setDocumentoSearch(evt.target.value)}
              />
              <Button
                type="primary"
                text="Buscar"
                disabled={modelName.loading}
                onClick={() => search()}
              />
            </div>

            <SelectInput
              value={plan}
              setValue={setPlan}
              label={<Etiqueta texto="Plan" obligatorio={true} />}
              options={planesOptions}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="CI" obligatorio={true} />}
              value={ci}
              disabled
              onChange={(evt) => setCi(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              disabled={documentFound}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <label>
              <Etiqueta texto="Fecha de inicio" obligatorio={true} />
            </label>

            <DatePicker

              dateFormat="dd/MM/yyyy"
              customInput={<input type="text" className="form-control" />}
              selected={fecha}
              onChange={(date) => setFecha(date)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddSuscripcion;
